import {
  BaSeParagraph,
  BaSeButton,
  BaSeDatePicker,
  BaSeHeading6,
  BaSeInput,
} from "@base/react";
import { Formik, Form } from "formik";
import Textarea from "../../../components/textarea";
import TipBlock from "../../../components/tip-block";
import useTutorial from "../../../hooks/useTutorial";
import logoTrophy from "../../../assets/images/trophy.svg";
import logoResult from "../../../assets/images/logo-result.svg";
import logoMonthlyCapacity from "../../../assets/images/monthly-capacity-logo.svg";

const TutorialResults = () => {
  const PAGE_KEY = "resultadosEMetas";

  useTutorial({
    currentStep: "14",
    pageKey: "resultadosEMetas",
    previousKey: "giroDeEstoque",
    steps: [
      {
        element: ".goal",
        popover: {
          title: "Resultados e Metas",
          description: `Defina metas claras para acompanhar o progresso do seu planejamento financeiro.
          Ajuste previsões, avalie variações de preços e otimize a rentabilidade do seu negócio.`,
          side: "bottom",
          align: "center",
        },
        onHighlighted: () => {
          const sideBar = document.querySelector(".list-menu");
          if (sideBar) {
            sideBar.classList.remove("open");
          }
        },
      },
    ],
    onNextButtonClick: (driverObj) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

      if (tutorials["fluxoCaixaProjetado"]) {
        tutorials["fluxoCaixaProjetado"].finalizado = false;
      }

      tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      const botaoProx = document.querySelector("#botaoSeguirTutorial button");
      botaoProx.click();
      driverObj.drive(0);
    },
  });

  return (
    <div className="step results">
      <TipBlock
        image={logoResult}
        borderColor="linear-gradient(to top, #84F4BC, #40BBFF)"
      >
        <BaSeHeading6 color="#005EB8" isBold>
          Resultados
        </BaSeHeading6>
      </TipBlock>

      <BaSeHeading6 className="title" color="#005EB8" isBold>
        Resultado - DD/MM/AAAA
      </BaSeHeading6>
      <>
        <div className="results-information">
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph isBold>Receita Total (RT)</BaSeParagraph>
            </span>
            <span className="results-information__value">
              <BaSeParagraph>R$ 0,00</BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph isBold>Custo Total (CT)</BaSeParagraph>
            </span>
            <span className="results-information__value">
              <BaSeParagraph>R$ 0,00</BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph isBold>Lucro (L)</BaSeParagraph>
            </span>
            <span className="results-information__value highlighted">
              <BaSeParagraph color="#005EB8" isBold>
                R$ 0,00
              </BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph color="#005EB8" isBold>
                Lucratividade (%LT)
              </BaSeParagraph>
            </span>
            <span className="results-information__value highlighted">
              <BaSeParagraph color="#005EB8" isBold>
                0%
              </BaSeParagraph>
            </span>
          </div>
        </div>
        <BaSeHeading6 className="title" color="#005EB8" isBold>
          Investimento
        </BaSeHeading6>

        <div className="results-information">
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph isBold>Investimento Financeiro</BaSeParagraph>
            </span>
            <span className="results-information__value">
              <BaSeParagraph>R$ 0,00</BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph isBold>Investimento Total</BaSeParagraph>
            </span>
            <span className="results-information__value">
              <BaSeParagraph>R$ 0,00</BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph color="#005EB8" isBold>
                Rentabilidade (mensal)
              </BaSeParagraph>
            </span>
            <span className="results-information__value highlighted">
              <BaSeParagraph color="#005EB8" isBold>
                0%
              </BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph color="#005EB8" isBold>
                Prazo de Retorno de Investimentos (anual)
              </BaSeParagraph>
            </span>
            <span className="results-information__value highlighted">
              <BaSeParagraph color="#005EB8" isBold>
                0,00
              </BaSeParagraph>
            </span>
          </div>
        </div>

        <BaSeHeading6 className="title" color="#005EB8" isBold>
          Capital de giro
        </BaSeHeading6>

        <div className="results-information">
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph isBold>
                Necessidade de Capital de Giro
              </BaSeParagraph>
            </span>
            <span className="results-information__value">
              <BaSeParagraph>R$ 0,00</BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph isBold>Capital de giro próprio</BaSeParagraph>
            </span>
            <span className="results-information__value">
              <BaSeParagraph>R$ 0,00</BaSeParagraph>
            </span>
          </div>
          <div className="results-information__data">
            <span className="results-information__info">
              <BaSeParagraph color="#005EB8" isBold>
                Necessidade de Formação de Capital de Giro
              </BaSeParagraph>
            </span>
            <span className="results-information__value highlighted">
              <BaSeParagraph color="#005EB8" isBold>
                R$ 0,00{" "}
              </BaSeParagraph>
            </span>
          </div>
        </div>
      </>

      <div className="bar"></div>

      <Formik>
        {() => (
          <Form className="form">
            <BaSeInput
              inputMode="decimal"
              typeInput="tel"
              prefix="% "
              maxLength={10}
              size="medium"
              placeholder="%"
              label="Variação geral das quantidades vendidas"
              width="100%"
              showHelpButton
              isDisabled
            />
            <Textarea
              isDisabled
              placeholder="Descreva a justificativa para variação geral das quantidades vendidas"
              label="Justificativa (opcional)"
            />

            <BaSeInput
              color="default"
              typeInput="tel"
              prefix="% "
              maxLength={10}
              size="medium"
              placeholder="%"
              label="Variação geral de preços de venda"
              width="100%"
              showHelpButton
              isDisabled
            />

            <Textarea
              isDisabled
              placeholder="Descreva a justificativa para variação geral das quantidades vendidas"
              label="Justificativa (opcional)"
            />

            <div className="bar"></div>

            <div className="second-tip-block">
              <TipBlock
                image={logoMonthlyCapacity}
                borderColor="linear-gradient(to top, #84F4BC, #40BBFF)"
              >
                <BaSeHeading6 color="#005EB8">
                  Capacidade Mensal de Pagamentos
                </BaSeHeading6>
              </TipBlock>
            </div>

            <div className="projected-flow">
              <BaSeParagraph color="#8B99A7">
                Você ainda não tem nenhum Fluxo de Caixa Projetado
              </BaSeParagraph>

              <BaSeButton
                isDisabled
                buttonType="button"
                color="#0E778B"
                value="Criar Fluxo de Caixa Projetado"
              />
            </div>

            <div className="bar"></div>

            <div className="goal">
              <img src={logoTrophy} alt="goal" />
              <div className="goal__input-area">
                <span style={{ display: "flex" }}>
                  <BaSeParagraph>
                    Estabeleça uma meta para cumprir o seu planejamento!
                  </BaSeParagraph>
                </span>

                <div className="date-picker">
                  <BaSeDatePicker
                    calendarType="days"
                    placeholder="Selecione sua data"
                    label="Meta do planejamento"
                    isDisabled
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TutorialResults;
